import { render, staticRenderFns } from "./UserPermissions.vue?vue&type=template&id=5c8ee7b1&scoped=true"
import script from "./UserPermissions.vue?vue&type=script&lang=ts"
export * from "./UserPermissions.vue?vue&type=script&lang=ts"
import style0 from "./UserPermissions.vue?vue&type=style&index=0&id=5c8ee7b1&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8ee7b1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c8ee7b1')) {
      api.createRecord('5c8ee7b1', component.options)
    } else {
      api.reload('5c8ee7b1', component.options)
    }
    module.hot.accept("./UserPermissions.vue?vue&type=template&id=5c8ee7b1&scoped=true", function () {
      api.rerender('5c8ee7b1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings-default/UserPermissions.vue"
export default component.exports